import { useLocalization } from "@plex/culture-react";

import { ILocale, defaultLocale } from "infrastructure/localization";

export function useLocalizedDefaultLocale(): ILocale {
  const { t } = useLocalization();

  return { name: t(defaultLocale.name), localeIdentifier: defaultLocale.localeIdentifier };
}
